import axios from 'axios';

const baseURL =
  (process.env.REACT_APP_BACKEND_URL || '').trim() || 'http://localhost:3334';

export interface IConfiguration {
  id: string;
  dental: boolean;
  medical: boolean;
  aesthetics: boolean;
  blocked: boolean;
  due_date: number;
  show_client_code: boolean;
  auto_schedule_confirmation_channel?:
    | 'disabled'
    | 'whatsapp'
    | 'email'
    | 'both';
  max_users?: number | null;
  max_professionals?: number | null;
  max_clients?: number | null;
  plan_id?: string;
  plan_status?: string;
  plan_started_at?: string;
  plan_ends_at?: string;
  plan?: IPlan | null;
  allowed_modules?: string[] | null;
  override_allowed_modules?: string[] | null;
}

export interface IPlan {
  id: string;
  code: string;
  name: string;
  description: string;
  landing_subtitle?: string | null;
  landing_price_label?: string | null;
  landing_frequency_label?: string | null;
  landing_highlight?: string | null;
  landing_features?: string[] | null;
  landing_sort_order?: number;
  landing_visible?: boolean;
  monthly_price_cents: number;
  max_users: number;
  max_professionals: number;
  max_clients: number;
  recommended_due_date: number;
  recommended_show_client_code: boolean;
  recommended_dental: boolean;
  recommended_medical: boolean;
  recommended_aesthetics: boolean;
  allowed_modules?: string[] | null;
  status: boolean;
}

export const getConfiguration = async (
  tenantId: string,
  token: string,
): Promise<IConfiguration | null> => {
  if (process.env.REACT_APP_TENANT_MANAGER_ID !== '128') {
    return null;
  }
  const api = axios.create({
    baseURL,
    headers: { 'x-tenant-id': tenantId, Authorization: `Bearer ${token}` },
  });
  const response = await api.get('/configurations');
  return response.data;
};

export const updateConfiguration = async (
  tenantId: string,
  id: string,
  data: Partial<IConfiguration>,
  token: string,
): Promise<any> => {
  const api = axios.create({
    baseURL,
    headers: { 'x-tenant-id': tenantId, Authorization: `Bearer ${token}` },
  });
  const response = await api.patch(`/configurations/${id}`, data);
  return response.data;
};

export const getConfigurationPlanSuggestions = async (
  tenantId: string,
  token: string,
): Promise<IPlan[]> => {
  const api = axios.create({
    baseURL,
    headers: { 'x-tenant-id': tenantId, Authorization: `Bearer ${token}` },
  });
  const response = await api.get('/configurations/plan-suggestions');
  return response.data;
};
